// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/lookup-workload-summary-request-schema',
  type: 'object',
  required: ['id', 'year'],
  properties: {
    id: {
      type: 'integer',
    },
    year: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
